import { Component, OnInit, ViewChild, Input, Output, HostListener, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import _ from 'lodash'
import { MatPaginator, MatDialog, MatSnackBar, PageEvent, MatPaginatorIntl } from '@angular/material';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { UserTimeSheetService } from '../../services/user-time-sheet.service'
import { LearnerService } from '../../services/learner.service'
import { TimeSheetService } from '../../services/time-sheet.service';
import { saveAs } from "file-saver";
import { JobHoursModelComponent } from '../learner-single-week/job-hours-model/job-hours-model.component';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { Observable, of } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AssetService } from 'src/app/services/asset.service';
import { ActivatedRoute, Router } from '@angular/router';
import { JobService } from 'src/app/services/jobs/job.service';
import { shiftInfo } from 'src/app/_models/staticArray'
import { StaffService } from 'src/app/services/staff/staff.service';
import { AdminReportBComponent } from '../admin-report-b/admin-report-b.component'
import * as moment from 'moment';
import { months } from '../../_models/staticArray'
import { FilterService } from 'src/app/services/filter.service';
import { LabourJobService } from '../../labour-job/labour-job.service';
import { ClientService } from '../../services/client.service';
import { UtilityService } from '../../services/utility.service';
import { _operativeTimesheetModalData, _adminTimesheetApprovalModalData, _adminTimesheetRejectionModalData } from '../../_models/staticArray'
import { CommentsComponent } from 'src/app/commons/comments/comments.component';
import { log } from 'console';


@Component({
  selector: 'app-user-single-week',
  templateUrl: './user-single-week.component.html',
  styleUrls: ['./user-single-week.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})




export class UserSingleWeekComponent implements OnInit {
  @Input('calWeekDates') doGetWeekDates;
  @Input('learner') learner;
  @Input('overTimeHours') overTimeHours;
  // @Input('learnerWeekArray') datesArrayFromLearner;
  @Input('weekDatesFromAdmin') weekDatesFromAdmin;
  @Input('monthChanged') monthChanged;
  // @Input('jobId') job
  @Input('userDetails') selectedUser
  @Input('allWeeks') weeks
  @Input('changeMonthDates') monthChangeValue
  @Input('displayedColumns') displayedColumns
  @Input('isStaff') isStaff
  @Input('loading') loadingtbl
  @Input('isAdminTimesheet') isAdminTimesheet
  @Input('allDays') allDays
  @Input('type') apiType
  @Input('instructorId') staffId
  @Input('isDailyTimeLog') isDailyTimeLog
  @Input('instructorData') singleInstData
  @Input('calculation') calculationDone
  @Input('jobId') currentJob
  @Input('jobPlannedTime') labourjobTime
  labourJobId
  labourjobPlannedTime
  @Input('otjh') offTheJobHrs
  dailyTimeLogColumns: any[] = ['Staff', 'Date', 'Start', 'End', 'Details', 'Travel Hours', 'Hours Worked', 'Travel + Working', 'Hours Worked [7 days]']
  // displayColumns: any[] = ['Copy', 'Date', 'Start', 'End', 'Job', 'Details', 'Shift Information', 'Reflection', 'Night Away', 'Travel Hours', 'Hours Worked', 'Travel + Working', 'Edit', 'Reset', 'Add']
  displayColumns: any[] = ['approve', 'Copy', 'Date', 'Start', 'End', 'Travel Hours', 'Hours Worked', 'Travel + Working', 'Status', 'Edit', 'Reset']
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  @Output() fatigueCalculation: EventEmitter<any> = new EventEmitter<any>();
  currentTime;
  learnerSelectType
  shiftInformation = shiftInfo
  totalHours = 0;
  showPasteBtn
  overH
  overM
  copiedIndex
  finalArray = []
  totalMinutes = 0;
  deletedLog = [];
  totalHoursWorked = { hours: 0, minutes: 0 };
  showTotalHoursColor
  loading
  Days = [];
  datesOfWeek;
  currentPage
  displayMsg
  hideActions = true;
  editing: boolean = false
  index
  editedIndex = [];
  arrayFromDb = []
  selectedJob
  learnerData
  hoursValid = true
  dataSource: MatTableDataSource<any>;
  pageSizeOptions: number[] = [25, 50, 100];
  sort: MatSort;
  paginator: MatPaginator;
  isPrint = true;
  // displayedColumns: string[] = ['copyPaste', 'weekNumber', 'weekStart', 'weekEnd', 'hoursWorked', 'details', 'otherDetails', 'edit', 'reset', 'view']
  timelogForm: FormGroup
  logsArray: FormArray
  days: any[];
  columnHeader: any[]
  isDeleteShow: boolean = false
  weekno: number;
  loading2: boolean;
  files = [];
  user: any;
  noFiles = {
    title: "No Files!",
    data: "No files added yet!"
  }
  mintime
  apiRef
  isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('expandedDetail');
  expandedElement: any;
  deletedFiles: any = [];
  previousIndex: any;
  notFileShow: boolean = false;
  isDisplay: boolean = false;
  jobArray: any = [];
  instructorId: any;
  userId: any;
  timeCalculated: any;
  today = new Date()
  jobId: any;
  instructorDetails
  fatigueIndex: boolean = false
  riskIndex: boolean = false
  previousDayTimeLog
  showFilter: boolean = false
  months = months
  selectedWeeks: any;
  selectedMonths;
  datesRange;
  allWeeks: any[];
  weekDates: unknown;
  weekNumber: any;
  getMonth: any
  filterActive = false
  afterFilter: any;
  plannedHours
  actualHours
  totalOTJH
  percent: string;
  totalHoursValid: boolean = true;
  isOtjhDisplay: boolean = false
  userRole
  isValidationError = false
  projectCodeList = []
  clientList = []
  selectedTimelog = []
  selectedFilter = "All";
  timelogStatusList = [];
  isApproved = false
  allYearweekList

  connect(): Observable<Element[]> {
    const rows = [];
    this.arrayFromDb.forEach(element => rows.push(element, { detailRow: true, element }));
    console.log(rows);
    return of(rows);

  }

  disconnect() { }

  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(AdminReportBComponent, { static: true }) timeSheet: AdminReportBComponent;



  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  subscription
  constructor(
    private _staffService: StaffService,
    private _jobService: JobService,
    private route: ActivatedRoute,
    private router: Router,
    public _assetService: AssetService,
    public formBuilder: FormBuilder,
    private _userTimeSheetServices: UserTimeSheetService,
    private _learnerService: LearnerService,
    private _snackBar: MatSnackBar,
    private _timeSheetSetvice: TimeSheetService,
    public dialog: MatDialog,
    public cd: ChangeDetectorRef,
    public _filter: FilterService,
    public _labourJobService: LabourJobService,
    public _clientService: ClientService,
    public _utilityService: UtilityService,
  ) {
    this.dataSource = new MatTableDataSource();
    this.subscription = this._userTimeSheetServices.downLoadReportPdf().subscribe((res) => {
      console.log("What is the response", res);
      if (this.apiType === 'adminSheet') this.printsingleWeekReport(res.format)
    })
  }

  // displayedColumns = ['test', 'test2 test']
  // displayedColumns123: string[] = ['copyPaste', 'date', 'start', 'finish', 'hoursWorked', 'details', 'otherdetails', 'edit', 'reset',];


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    console.log("display column -------------------------->", this.displayedColumns);
    console.log("this.days in ngOnInit()", this.days);
    // this.paginator = new MatPaginator(new MatPaginatorIntl(), this.cd);

    // if (!this.days)
    // this.loading2 = true
    console.log("this.expandedElement in ngOnInit()", this.expandedElement);
    this.user = JSON.parse(localStorage.getItem('currentUser'))
    this.userRole = JSON.parse(localStorage.getItem('userRoles'))
    this.showFilter = this.router.url.includes('/user-single-week')
    console.log("this.router.url", this.showFilter);
    this.route.queryParams.subscribe(params => {
      console.log('Query Params=>', params);
      if (params && params.instructorId && !params.type) {
        this.datesOfWeek = params.datesOfTheWeek;
        this.instructorId = params.instructorId;
        this.userId = params.userId;
        this.displayedColumns = this.displayColumns
        this.apiRef = 'userSheet'
        // this.getJobUsingInstructorId(params.instructorId)
        this.getInstructor(this.instructorId)
      } else if (params.type === 'adminSheet') {
        console.log("This is for operative user");
        this.datesOfWeek = params.datesOfTheWeek
        this.instructorId = params.instructorId
        this.userId = params.userId
        this.apiRef = params.type
        this.apiType = params.type
        this.displayedColumns = this.displayColumns
        this.isStaff = true
        // this.getJobUsingInstructorId(this.instructorId)
        if (params.month) {
          this.getAllYearWeeks().then((res) => {

            this.getMonth = params.month
            this.selectedMonths = months.find(month => month.id == params.month)
            this.weekNumber = params.weekNumber
            this.generateMonthWeeks()
          })
        }
        //  else {
        //   this.getTimeLogs('test11')
        // }
        this.getInstructor(this.instructorId)
      }
    });
    if (this.isAdminTimesheet) this.displayedColumns = this.displayColumns
    this.createForm()
    // this.getProjectCodeList()
    this.getClientList()



    if (this.userRole.isAdmin) {
      this.timelogStatusList = [
        { value: "all", viewValue: "All" },
        { value: "pending", viewValue: "Pending" },
        { value: "approved", viewValue: "Approved" },
      ];
    } else {
      this.timelogStatusList = [
        { value: "all", viewValue: "All" },
        { value: "draft", viewValue: "Draft" },
        { value: "submitted", viewValue: "Submitted" },
        { value: "approved", viewValue: "Approved" }
      ];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.loading = true
    console.log("ng on changes here !!!!!!!!!!!!!!!!!!!!!!!!!", changes)
    if ((changes.monthChanged && changes.monthChanged.currentValue == true) || changes.doGetWeekDates && changes.doGetWeekDates.currentValue == true) {
      console.log("check here work get week")
    }

    if (changes.apiType && changes.apiType.currentValue) {
      this.apiRef = changes.apiType.currentValue
    }
    if (changes.selectedUser && changes.selectedUser.currentValue) {
      this.learnerData = changes.selectedUser.currentValue.user
      this.jobId = changes.selectedUser.currentValue.jobId
      this.getTimeLogs('test1')
      this.createForm()
      console.log("learner data in chile component", this.learnerData);
    }

    if (changes.displayedColumns && changes.displayedColumns.currentValue) {
      this.displayedColumns = changes.displayedColumns.currentValue
    }
    if (changes.weeks && changes.weeks.currentValue) {
      this.datesOfWeek = changes.weeks.currentValue
    }

    if (changes.monthChangeValue && changes.monthChangeValue.currentValue) {
      this.datesOfWeek = changes.monthChangeValue.currentValue
    }

    if (changes.allDays && changes.allDays.currentValue && changes.allDays.currentValue.length) {
      console.log('changes.allDays', changes.allDays.currentValue)
      this.datesOfWeek = changes.allDays.currentValue
    }

    if (changes.staffId && changes.staffId.currentValue) {
      this.instructorId = changes.staffId.currentValue
      console.log("THIS IS THE FINAL STAFF ID", this.instructorId);

      // this.router.navigate([], {
      //   relativeTo: this.route, queryParams: { user: this.instructorId }, queryParamsHandling: 'merge'
      // });
    }

    if (changes.isAdminTimesheet && changes.isAdminTimesheet.currentValue) {
      this.isAdminTimesheet = changes.isAdminTimesheet.currentValue

    }



    if (changes.singleInstData && changes.singleInstData.currentValue) {
      this.instructorDetails = changes.singleInstData.currentValue
      console.log("this is the value for cpd", this.instructorDetails.userId._id);
      if (this.apiRef == 'cpd') this.getTimeLogs('test3')
    }
    if (changes.isDailyTimeLog && changes.isDailyTimeLog.currentValue) {
      this.isDailyTimeLog = changes.isDailyTimeLog.currentValue
      this.displayedColumns = this.dailyTimeLogColumns
      this.getTimeLogs('test2')
    }
    if (changes.currentJob && changes.currentJob.currentValue) this.labourJobId = changes.currentJob.currentValue

    if (changes.calculationDone && changes.calculationDone.currentValue) {
      let calculation = changes.calculationDone.currentValue
      if (calculation) this.getTimeLogs('test4')
    }

    if (changes.labourjobTime && changes.labourjobTime.currentValue) {
      this.labourjobPlannedTime = changes.labourjobTime.currentValue
      this.displayedColumns = ['Copy', 'Date', 'Planned Start', 'Actual Start', 'Planned End', 'Actual End', 'Travel Hours', 'Hours Worked', 'Travel + Working', 'Edit', 'Reset']
    }


    if (this.instructorId && this.isAdminTimesheet && this.weeks && this.weeks.length && this.instructorDetails && !this.isDailyTimeLog) {
      console.log("this.instructorId Details", this.instructorId, this.isAdminTimesheet, this.weeks, this.weeks.length, this.instructorDetails, !this.isDailyTimeLog);
      // this.getJobUsingInstructorId(this.instructorId)
      this.getTimeLogs('test5')
    }

    if (changes.offTheJobHrs && changes.offTheJobHrs.currentValue) {
      this.totalOTJH = changes.offTheJobHrs.currentValue
    }

    console.log("this condition is called for multiple time", 'test2', this.displayedColumns);

  }

  // CREATE FORM

  createForm(details?) {
    console.log("details while edit form", details);
    this.timelogForm = new FormGroup({
      logsArray: this.formBuilder.array(this.multipleControl((details && details.length) ? details : []))
    })
    console.log("this is the data of form array", this.timelogForm.value.logsArray);

    this.updateData(this.filterActive ? [] : this.timelogForm.value.logsArray)

  }


  get multipleVisitorsGroup() { return <FormArray>this.timelogForm.get('logsArray') }

  // UTILITY FUNCTION


  checkAllTimelogs(event) {
    // console.log("CHECK LOGS", event)
    const logs = this.multipleVisitorsGroup.controls;
    for (let i = 0; i < logs.length; i++) {
      if (event && event.checked === true && !logs[i].value.isDisable && logs[i].value._id !== 'new' && !logs[i].value.isJob) {
        logs[i].patchValue({ checked: true })
        const obj = {
          logId: logs[i].value._id,
          userId: this.userId && this.userId != undefined ? this.userId : this.instructorDetails.userId._id,
          status: logs[i].value.status,
          date: logs[i].value.date
        };
        this.selectedTimelog.push(obj);
      }
      else {
        logs[i].patchValue({ checked: false })
      }
    }

    if (event && event.checked === true && this.selectedTimelog && this.selectedTimelog.length) {
      this.isApproved = true
      this.submitTimelogForApproval()
    }
    if (this.selectedTimelog && !this.selectedTimelog.length && event && event.checked === true) {
      this._utilityService.openSnackBar("No logs are eligible for Approval.", "OK");
    }

  }


  checkSelectionTimelog(event, item) {
    console.log("item : ", item);
    // let status;
    if (event && event.checked === true) {
      const obj = {
        logId: item._id,
        userId: this.userId && this.userId != undefined ? this.userId : this.instructorDetails.userId._id,
        status: item.status,
        date: item.date
      };
      this.selectedTimelog.push(obj);
    } else {
      const index = _.findIndex(this.selectedTimelog, function (o) {
        return o.logId === item._id && o.date === item.date;
      });
      this.selectedTimelog.splice(index, 1);
    }
    console.log("this.selectedTimelog :: ", this.selectedTimelog);
  }

  updateData(weekDays?) {
    // console.log("UPDATING DATA of table = ", weekDays.controls)
    // this.padZeroInLogs(weekDays)
    this.dataSource = new MatTableDataSource((this.timelogForm.get('logsArray') as FormArray).controls);
    // this.dataSource = weekDays
    // this.createForm()
    console.log("this is data source", this.dataSource);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("item", item, "property", property)
      switch (property) {
        // case 'displayTitle': return item.assignment.title
        // case 'deadlineDate': return item.deadlineDate;
        // case 'type': return item.assignment.type
        // case 'status': return item.status

        default: return item[property]
      }
    }


    this.dataSource.sort = this.sort;
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
    this.loading = false
    this.cd.detectChanges()
  }



  filter(searchText) {
    // console.log("What is the value of search text", searchText);
    // console.log('FILTER CALLED', searchText);
    if (searchText === '') {
      this.filterActive = false;
      this.createForm(this.days);
      return;
    }
    let tempDataSource = this._filter.timesheetFilter(searchText, this.days, ['name' , 'sentinelNumber']);
    // console.log("tempDataSource", tempDataSource);

    this.createForm(tempDataSource)
    if (tempDataSource.length <= 0) {
      this.filterActive = true
      this.afterFilter = {
        title: "No Staff!",
        data: "Sorry, no staff name matched your search"
      }
      // this.afterFilter = "No jobs with search text found!"
    }
  }

  // Generate months week

  generateMonthWeeks() {
    this.selectedWeeks = []
    this.monthChanged = true
    console.log("selected months.......", this.selectedMonths);

    let year = moment().year()
    let monthWeeks = []
    this.allYearweekList.filter((x) => {
      if ((Number(x.month) === (Number(this.selectedMonths.id) + 1)) && (Number(x.year) === Number(year))) {
        // console.log("THIS IS THE SELECTED MONTH WEEK", x)
        let obj = {
          weekNumber: x.weekNumber, weekStartDate: x.startDate, weekEndDate: x.endDate,
          from: moment(x.startDate).format('DD/MM/YYYY'),
          to: moment(x.endDate).format('DD/MM/YYYY'),
          bothDates: "From: " + moment(x.startDate).format('DD/MM/YYYY') + " - " + "To: " + moment(x.endDate).format('DD/MM/YYYY'),
          dateList: x.dateList
        }
        monthWeeks.push(obj)
        // x
      }
    })
    console.log("monthWeeks", monthWeeks);
    this.datesRange = monthWeeks
    this.weekDates = monthWeeks
    if (this.weekNumber) {
      this.selectedWeeks = this.datesRange.find(date => date.weekNumber == this.weekNumber)
      console.log("THIS IS SELECTED WEEKS", this.selectedWeeks)
      this.generateWeekDates()
    }

    // this._timeSheetSetvice.generateMonthWeeks(this.selectedMonths).then((res: any) => {
    //   console.log("What is the res of selected month", res);
    //   this.allWeeks = res.allweeks
    //   this.datesRange = res.datesRange
    //   this.weekDates = res.datesRange
    //   if (this.weekNumber) {
    //     this.selectedWeeks = this.datesRange.find(date => date.weekNumber == this.weekNumber)
    //     this.selectedWeeks['bothDates'] = "From: " + moment(this.selectedWeeks.from).format('DD/MM/YYYY') + " - " + "To: " + moment(this.selectedWeeks.to).format('DD/MM/YYYY')
    //     console.log("THIS IS THE SELECTED WEEK NUMBER", this.selectedWeeks.bothDates)
    //     this.generateWeekDates()
    //   }
    // }).catch((err) => {
    //   console.log('err', err)
    // })
  }
  generateWeekDates() {
    // this.monthChanged = false

    // this._timeSheetSetvice.generateWeekDates(this.selectedWeeks).then((res: any) => {
    //   console.log("What is the res of selected month123", res)
    //   this.datesOfWeek = res.weekDates
    //   this.getTimeLogs()
    // }).catch((err) => {
    // })
    if (this.selectedWeeks) {
      this.monthChanged = false
      this.datesOfWeek = this.selectedWeeks.dateList
      this.getTimeLogs()
    }
  }

  clearMonth() {
    this.selectedWeeks = []
    this.selectedMonths = months.find(month => month.id == this.getMonth)
    this.generateMonthWeeks();
  }
  multipleControl(logs): Array<any> {
    console.log("data in multiple control", logs);
    // this.weekno = logs.length
    if (logs && logs.length) {
      let logsArray = []
      if (this.instructorId || this.isAdminTimesheet || this.isDailyTimeLog) {
        _.forEach(logs, async (log) => {
          console.log("log==============>1", log);
          await logsArray.push(new FormGroup({
            hours: new FormControl(''),
            minutes: new FormControl(''),
            workingHours: new FormControl(log.workingHours),
            _id: new FormControl(log._id),
            date: new FormControl(moment(log.date).format('DD/MM/YYYY')),
            start: new FormControl(log.start),
            end: new FormControl(log.end),
            job: new FormControl(log.job),
            extraDetails: new FormControl(log.details.extraDetails),
            isJob: new FormControl(log.isJob),
            isDisable: new FormControl(log.isDisable),
            other: new FormControl(log.details.other),
            details: new FormControl(log.details),
            shiftInfo: new FormControl(log.details.shiftInfo),
            travel: new FormControl(log.travel),
            nightAway: new FormControl(log.details.nightAway),
            isDeleteShow: new FormControl(log.isDeleteShow),
            totalHours: new FormControl(log.totalHours),
            totalColor: new FormControl(log.totalColor),
            pastdaysLogs: new FormControl(log.finalHours && log.finalHours.travelWorking ? log.finalHours.travelWorking : "00:00"),
            workingColor: new FormControl(log.workingColor),
            user: new FormControl(log.user),
            livingAllowance: new FormControl(log.details.livingAllowance ? log.details.livingAllowance : false),
            payRate: new FormControl(log.details.payRate ? log.details.payRate : ''),
            paidHours: new FormControl(log.details.paidHours ? log.details.paidHours : ''),
            projectCode: new FormControl(log.details.projectCode ? log.details.projectCode : ''),
            multipleLogs: new FormControl(log.multipleLogs && log.multipleLogs.length ? log.multipleLogs : []),
            expense: new FormControl(log.details.expense ? log.details.expense : false),
            deduction: new FormControl(log.details.deduction ? log.details.deduction : false),
            multipleDeduction: new FormControl(log.multipleDeduction && log.multipleDeduction.length ? log.multipleDeduction : []),
            multipleExpense: new FormControl(log.multipleExpense && log.multipleExpense.length ? log.multipleExpense : []),
            status: new FormControl(log.status ? log.status : 'draft'),
            checked: new FormControl(false),
          }))
        })
        return logsArray;
      } else {
        _.forEach(logs, async (log) => {
          console.log("log==============>2", log);
          await logsArray.push(new FormGroup({
            // weekNumber: new FormControl(count[i - 1]),
            weekNumber: new FormControl(log.weekNumber),
            weekStartDate: new FormControl(log.weekStartDate),
            weekEndDate: new FormControl(log.weekEndDate),
            workingHours: new FormControl(log.workingHours),
            extraDetails: new FormControl(log.details.extraDetails),
            other: new FormControl(log.details.other),
            _id: new FormControl(log._id),
            hours: new FormControl(log.hours),
            minutes: new FormControl(log.minutes),
            files: new FormControl((log.files && log.files.length) ? log.files : []),
          }))
        })
        return logsArray;
      }
    } else {
      if (this.instructorId || this.isAdminTimesheet || this.isDailyTimeLog) {
        return [this.formBuilder.group({
          hours: new FormControl(''),
          minutes: new FormControl(''),
          workingHours: new FormControl(''),
          _id: new FormControl(''),
          date: new FormControl(''),
          start: new FormControl(''),
          end: new FormControl(''),
          // job: new FormControl(null),
          extraDetails: new FormControl(''),
          other: new FormControl(''),
          shiftInfo: new FormControl(''),
          travel: new FormControl(''),
          nightAway: new FormControl(false),
          isDeleteShow: new FormControl(false),
          totalHours: new FormControl(''),
          pastdaysLogs: new FormControl(''),
          user: new FormControl(''),
          livingAllowance: new FormControl(false),
          status: new FormControl(''),
          // isDisable: new FormControl(false),
        })
        ]
      } else {
        return [this.formBuilder.group({
          weekNumber: new FormControl(''),
          weekStartDate: new FormControl(''),
          weekEndDate: new FormControl(''),
          workingHours: new FormControl(''),
          extraDetails: new FormControl(''),
          other: new FormControl(''),
          _id: new FormControl(''),
          hours: new FormControl(''),
          minutes: new FormControl(''),
          files: new FormControl([]),
        })
        ]
      }
    }
  }

  /***
  * date update function here !!!!!!!!!!!!!!!!!!!!!!!!!1
  */
  edit(i, pageEvent) {
    this.hoursValid = true;
    this.notFileShow = true;
    console.log("what is the index value", i);
    // this.weekno = i + this.weekno
    this.timelogForm.value.logsArray[i].update = true
    console.log("this.timelogForm.value.logsArray update ....", this.timelogForm.value.logsArray);

    // this.days[i]['updated'] = true
    if (pageEvent && pageEvent.pageIndex) {
      this.currentPage = pageEvent.pageIndex
    }
    else { this.currentPage = 0 }
    console.log("On edit adding class to", '#' + this.currentPage + i);
    $('#' + this.currentPage + i).addClass('make-blue')
    console.log("index", i);
    this.index = i
    this.editedIndex.push({ currentPage: this.currentPage, index: i })
    console.log("in edit this.editedIndex", this.editedIndex);
    this.editing = true
    console.log("this is the selected index data", this.index);

    console.log("**CURRENT PAGE", this.currentPage);

  }
  getActualIndex(index: number) {
    // console.log("index====>", index);
    return index + this.paginator.pageSize * this.paginator.pageIndex;
  }

  resetCurrentLogs(i) {
    console.log("index===>", i)
    this.notFileShow = true
    this.openSnackBar("Logs will be updated after save!", "OK")
    console.log("this.timelogForm.controls.logsArray.value", this.timelogForm.controls.logsArray.value);
    this.deletedFiles = this.timelogForm.value.logsArray[i].files
    const control = <FormArray>this.timelogForm.controls.logsArray
    control.at(i).patchValue({ workingHours: '00:00' })
    control.at(i).patchValue({ extraDetails: '' })
    control.at(i).patchValue({ other: '' })
    control.at(i).patchValue({ files: [] })
    if (this.instructorId) {
      control.at(i).patchValue({ start: '00:00' })
      control.at(i).patchValue({ end: '00:00' })
      control.at(i).patchValue({ totalHours: '00:00' })
      control.at(i).patchValue({ travel: '00:00' })
      control.at(i).patchValue({ job: this.timelogForm.value.logsArray[i].job || null })
      control.at(i).patchValue({ shiftInfo: '' })
      control.at(i).patchValue({ nightAway: false })
      control.at(i).patchValue({ livingAllowance: false })
      control.at(i).patchValue({ multipleLogs: [] })
      control.at(i).patchValue({ multipleExpense: [] })
      control.at(i).patchValue({ payRate: '' })
      control.at(i).patchValue({ paidHours: '' })
      control.at(i).patchValue({ expense: false })
    }

    if (this.timelogForm.value.logsArray[i]._id && this.timelogForm.value.logsArray[i]._id != 'new') {
      this.deletedLog.push(this.timelogForm.value.logsArray[i]._id)
    }
    console.log('this.deletedFiles  Logs==>', this.deletedFiles);
    console.log('Deleted Logs==>', this.deletedLog);
  }

  addTimeLogs(event) {
    console.log("event when enter something", event.target.value);
    let regex = new RegExp(/^([0-9][0-9]):[0-5][0-9]$/g)
    this.hoursValid = regex.test(event.target.value);
    if (this.hoursValid) {
      console.log("this.houursValid", this.hoursValid)
      this.totalWorkingHours()
    } else {
      console.log("this is not valid");

    }

  }

  uploadFile(index) {
    this.files = []
    // let data = this.learnerData.userId._id
    let data = {
      isCpd: true
    }
    this.openDialog(NewFileModalComponent, data).subscribe(uploaded => {
      console.log("uploaded", uploaded);

      if (uploaded && uploaded.length) {
        for (let i = 0; i < uploaded.length; i++) {
          uploaded[i].name = this.user.name
          this.files.push(uploaded[i]);
          // this.timelogForm.value.logsArray[index].file.push(uploaded[i])
        }
      }
      this.timelogForm.value.logsArray[index].file = this.files
      // if (uploaded) {
      //   // this.files.push(uploaded);
      //   this.timelogForm.value.logsArray[index].file = this.files
      // }

      console.log("file-->", this.files);
      console.log("this.timelogForm.value.logsArray-->", this.timelogForm.value.logsArray);
      // this.files = []

    })

  }

  selectShiftChanged(event, index) {
    console.log("selectedJobChanged() method call", event, index);
    const control = <FormArray>this.timelogForm.controls.logsArray
    control.at(index).patchValue({ shiftInfo: event.value })
  }

  selectedJobChanged(event, index) {
    console.log("selectedJobChanged() method call", event, index);
    const control = <FormArray>this.timelogForm.controls.logsArray
    control.at(index).patchValue({ job: event.value })
  }

  timeChanged(event, index, formControl) {
    console.log("event, index, formControl", event, index, formControl);
    console.log("this.timelogForm.value", this.timelogForm.value);
  }

  addTimeLogRow(index) {
    const control = <FormArray>this.timelogForm.controls.logsArray
    // control.at(index).patchValue({ isDeleteShow: true })
    let temp = control.at(index).get('date')
    console.log("temp------->", temp);
    _.forEach((this.timelogForm.value.logsArray), (singleDate, i) => {
      if (singleDate.date == temp.value) {
        control.at(i).patchValue({ isDeleteShow: true })
      }
    })
    control.insert(index + 1, (this.formBuilder.group({
      hours: new FormControl(''),
      minutes: new FormControl(''),
      workingHours: new FormControl('00:00'),
      _id: new FormControl('new'),
      date: new FormControl(this.timelogForm.value.logsArray[index].date),
      start: new FormControl('00:00'),
      end: new FormControl('00:00'),
      job: new FormControl(null),
      extraDetails: new FormControl(''),
      other: new FormControl(''),
      shiftInfo: new FormControl(''),
      travel: new FormControl('00:00'),
      nightAway: new FormControl(false),
      isDeleteShow: new FormControl(true),
      totalHours: new FormControl('00:00'),
      livingAllowance: new FormControl(false)
    })))
    this.updateData(this.timelogForm.value.logsArray)
    console.log("this is the data of form array", this.timelogForm.value.logsArray);
  }

  deleteTimeLogRow(element, index) {
    console.log("element, index", element, index);
    const control = <FormArray>this.timelogForm.controls.logsArray
    let tempDate = this.timelogForm.value.logsArray[index].date
    let count = 0
    let tempIndex
    console.log("this.timelogForm.value.logsArray[index - 1]", this.timelogForm.value.logsArray[index]);
    control.removeAt(index)
    for (let i = 0; i < this.timelogForm.value.logsArray.length; i++) {
      if (tempDate == this.timelogForm.value.logsArray[i].date) {
        count++;
        tempIndex = i;
      }
    }
    if (count == 1) {
      control.at(tempIndex).patchValue({ isDeleteShow: false })
    }
    this.updateData(this.timelogForm.value.logsArray)
  }

  // fileDetails(event) {
  //   console.log("event ====", event);
  //   this.previousIndex = event.index
  //   // this.openFilesSideNav.emit({ event })
  //   this.openFilesSideNav.emit({ event })
  //   this._learnerService.displayFile(event)
  //   // this.openDialog(FileDetailsComponent, event.file).subscribe(file=>{
  //   //   console.log("Test")
  //   // })

  // }

  fileDetails(event) {
    console.log("hey this event emit call ")
    console.log("event ====", event.file);
    this.previousIndex = event.index
    this.openFilesSideNav.emit({ event })
    this._assetService.displayFile(event)
  }


  dateChanged(event) {
    this.displayMsg = false
    this.dataSource = new MatTableDataSource()
    console.log("event", event);
    this.today = new Date(event)
    this.getTimeLogs('test6')
  }

  /***
  * *************************************************************
  * Total working hours ***************************************************
  */
  totalWorkingHours() {
    console.log("this.timelogForm.controls.logsArray", this.timelogForm.controls.logsArray);
    console.log('call After Api call');
    var totalH = 0;
    var totalM = 0;
    _.forEach(this.timelogForm.controls.logsArray.value, (day, index) => {
      console.log("here is single day value!!!!!!", day)
      let hours = day.workingHours.split(':')
      console.log("what is the split value", hours);

      totalH = totalH + Number(hours[0]);
      totalM = totalM + Number(hours[1]);
    })
    if (totalM > 60) {
      totalH = totalH + Math.floor(totalM / 60)
      totalM = totalM % 60
      this.totalHoursWorked.hours = totalH;
      this.totalHoursWorked.minutes = totalM;
      console.log('This.totalHoursWorked', this.totalHoursWorked);

      // this.checkTravelPlusWorkHour()
    } else if (totalM == 60) {
      this.totalHoursWorked.hours = totalH + 1;
      this.totalHoursWorked.minutes = totalM - 60
      console.log('This.totalHoursWorked', this.totalHoursWorked);

    }
    else {
      this.totalHoursWorked.hours = totalH;
      this.totalHoursWorked.minutes = totalM;
      console.log('This.totalHoursWorked', this.totalHoursWorked);

    }
    console.log('This.totalHoursWorked', this.totalHoursWorked);
  }

  columnName(i) {
    console.log("------------i----------", i);
    if (i == 'one') return 'Action'
  }
  /****
   * copy paste using button timeloh
   */

  copyCurrentLogs(i) {
    this.copiedIndex = i;
    this.showPasteBtn = true
    this.notFileShow = true
  }


  checkValidationLog(i) {
    let newLogs = <FormArray>this.timelogForm.controls.logsArray.value
    let coppyLogVal = this.timelogForm.controls.logsArray.value[this.copiedIndex]
    console.log("CURRENT LOG INDEX WITH DATA", newLogs[i], coppyLogVal)
    // console.log("COPPY LOG VALUE", coppyLogVal)
    if (newLogs[i].date !== coppyLogVal.date) return false
    else {
      let currentStartTime = this.getDateTime(coppyLogVal.date, coppyLogVal.start)
      let currentEndTime = this.getDateTime(coppyLogVal.date, coppyLogVal.end)
      const validStart = this.checkValidTime(currentStartTime, coppyLogVal, i)
      const validEnd = this.checkValidTime(currentEndTime, coppyLogVal, i)
      console.log("WHAT IS THE VALUE OF START AND STOP TIME VALIDATION", validStart, validEnd)
      if (validStart || validEnd) return true
      else return false
    }
  }

  getDateTime(date, time) {
    const splitTime = time.split(':')
    const totalMinutes = Number(splitTime[0] * 60) + Number(splitTime[1])
    const finalTime = new Date(new Date(date).getTime() + totalMinutes * 60000);
    return finalTime
  }



  checkValidTime(currentTime, log, logIndex) {
    console.log("LOGINDEX VALUE", logIndex, log)
    let existingLogs = <FormArray>this.timelogForm.controls.logsArray.value.filter((x, index) => x.date === log.date && index !== logIndex)
    let validTime = false
    console.log("EXISTING LOGS FOR SAME DATE", existingLogs)
    if (existingLogs && existingLogs.length) {
      const logsLength = existingLogs.length
      for (let i = 0; i < logsLength; i++) {
        let startTime = this.getDateTime(existingLogs[i].date, existingLogs[i].start)
        let endTime = this.getDateTime(existingLogs[i].date, existingLogs[i].end)
        const valid = startTime <= currentTime && endTime >= currentTime
        // console.log("WHAT IS THE VALID CHECK VALUE", valid)
        if (valid) validTime = valid
      }
      return validTime
    } else return validTime
  }

  pasteLogs(i) {
    console.log("index of paste logs", i, this.copiedIndex);
    this.showPasteBtn = false
    this.openSnackBar("Logs will be paste after save!", "OK")
    console.log("this.timelogForm.controls.logsArray[this.copiedIndex]", this.timelogForm.controls.logsArray);
    const checkValidation = this.checkValidationLog(i)
    if (!checkValidation) {
      let newLogs = <FormArray>this.timelogForm.controls.logsArray
      newLogs.at(i).patchValue({ workingHours: this.timelogForm.controls.logsArray.value[this.copiedIndex].workingHours })
      newLogs.at(i).patchValue({ extraDetails: this.timelogForm.controls.logsArray.value[this.copiedIndex].extraDetails })
      newLogs.at(i).patchValue({ other: this.timelogForm.controls.logsArray.value[this.copiedIndex].other })
      newLogs.at(i).patchValue({ livingAllowance: this.timelogForm.controls.logsArray.value[this.copiedIndex].livingAllowance })
      newLogs.at(i).patchValue({ deduction: this.timelogForm.controls.logsArray.value[this.copiedIndex].deduction })
      newLogs.at(i).patchValue({ expense: this.timelogForm.controls.logsArray.value[this.copiedIndex].expense })
      newLogs.at(i).patchValue({ payRate: this.timelogForm.controls.logsArray.value[this.copiedIndex].payRate })
      newLogs.at(i).patchValue({ paidHours: this.timelogForm.controls.logsArray.value[this.copiedIndex].paidHours })
      if (this.instructorId) {
        newLogs.at(i).patchValue({ start: this.timelogForm.controls.logsArray.value[this.copiedIndex].start })
        newLogs.at(i).patchValue({ end: this.timelogForm.controls.logsArray.value[this.copiedIndex].end })
        // newLogs.at(i).patchValue({ job: this.timelogForm.controls.logsArray.value[this.copiedIndex].job })
        newLogs.at(i).patchValue({ projectCode: this.timelogForm.controls.logsArray.value[this.copiedIndex].projectCode })
        newLogs.at(i).patchValue({ shiftInfo: this.timelogForm.controls.logsArray.value[this.copiedIndex].shiftInfo })
        newLogs.at(i).patchValue({ nightAway: this.timelogForm.controls.logsArray.value[this.copiedIndex].nightAway })
        newLogs.at(i).patchValue({ travel: this.timelogForm.controls.logsArray.value[this.copiedIndex].travel })
        newLogs.at(i).patchValue({ totalHours: this.timelogForm.controls.logsArray.value[this.copiedIndex].totalHours })
        newLogs.at(i).patchValue({ multipleLogs: this.timelogForm.controls.logsArray.value[this.copiedIndex].multipleLogs })
        newLogs.at(i).patchValue({ status: this.timelogForm.controls.logsArray.value[this.copiedIndex].status })
        let preObj = this.timelogForm.controls.logsArray.value[this.copiedIndex]
        let multipleExpenseList = []
        let multipleDeductionList = []
        if (preObj.multipleDeduction && preObj.multipleDeduction.length) {
          preObj.multipleDeduction.filter((x) => {
            multipleDeductionList.push({
              deductionType: x.deductionType,
              deductionAmount: x.deductionAmount,
              deductionDate: this._userTimeSheetServices.covertDateFormate(newLogs.at(i).value.date, 'MM/DD/YYYY'),
              userId: this.userId ? this.userId : this.instructorDetails.userId._id
            })
          })
        }
        if (preObj.multipleExpense && preObj.multipleExpense.length) {
          preObj.multipleExpense.filter((x) => {
            multipleExpenseList.push({
              expenseType: x.expenseType,
              expenseAmount: x.expenseAmount,
              expenseEvidence: x.expenseEvidence,
              expenseDate: this._userTimeSheetServices.covertDateFormate(newLogs.at(i).value.date, 'MM/DD/YYYY'),
              userId: this.userId ? this.userId : this.instructorDetails.userId._id
            })
          })
        }
        newLogs.at(i).patchValue({ multipleExpense: multipleExpenseList })
        newLogs.at(i).patchValue({ multipleDeduction: multipleDeductionList })
      }
      console.log("this has been paste logs", newLogs);
      $('#' + this.currentPage + i).addClass('make-blue')
      this.editedIndex.push({ currentPage: this.currentPage, index: i })
      console.log("after paste logs", newLogs);
      this.totalWorkingHours();
      this.notFileShow = true
    } else {
      // this.isValidationError = true
      this.openSnackBar("Logs already added for this time on this day", "OK")
      console.log("HERE TO DISPLAY ERROR MESSAGE", this.isValidationError)
    }
  }
  calculatePaidAmount() {
    let total = 0
    this.timelogForm.value.logsArray.filter((x) => {
      if (x && x.paidHours !== '' && x.payRate !== '') {
        console.log("WHAT IS X", x)
        console.log("STAFF DATA", this.instructorDetails.details)
        let amount = this.instructorDetails.details[x.payRate]
        console.log("WHAT IS THE AMOUNT OF THIS", amount)
        if (amount) {
          total = total + (Number(x.paidHours) * Number(amount))
          x['singleDayPaidAmount'] = Number(x.paidHours) * Number(amount)
        }
      }
    })
    console.log("WHAT IS THE TOTAL AMOUNT", total)
    return total
  }






  filterLogs(logs) {
    logs = logs.filter((x) => {
      if (x.job) {
        console.log("x.job", x);
        const element = this.jobArray.find((y) => y._id === x.job._id)
        console.log("ELEMENT FIND", element)
        if (element != undefined) x.job['projectCode'] = element.projectCode
      }
      return x
    })
    return logs
  }

  printsingleWeekReport(format) {
    console.log("What is the api sheet type", this.apiType);

    this.loading2 = true;
    $('#loader-wrapper-2').show()

    this.openSnackBar("Download will begin automatically", "Ok");
    let data
    console.log("this.timeCalculated................", this.learnerData);

    // if (this.instructorId) {
    if (this.apiType === "adminSheet") {
      console.log("this.instructorId", this.datesOfWeek);
      data = {
        logs: this.filterLogs(this.timelogForm.value.logsArray),
        instructor: this.instructorDetails,
        // jobData: this.jobArray,
        totalTime: this.timeCalculated,
        periodStart: this.datesOfWeek[0],
        periodEnd: this.datesOfWeek[this.datesOfWeek.length - 1],
        type: this.apiType,
        format: format,
        totalPaidAmount: this.calculatePaidAmount(),
        isAmountView: this.userRole && this.userRole.isAdmin ? true : false
      }
    } else if (this.apiType === "dailySheet") {
      console.log("this.timelogForm.value.logsArray..........", this.timelogForm.value.logsArray)
      data = {
        logs: this.timelogForm.value.logsArray,
        // date: this.timelogForm.value.logsArray[0].date,
        date: this._userTimeSheetServices.covertDateFormate(this.timelogForm.value.logsArray[0].date, 'MM/DD/YYYY'),
        instructor: this.instructorDetails,
        // jobData: this.jobArray,
        totalTime: this.timeCalculated,
        type: this.apiType,
        format: format
      }
    } else {

      if (this.apiType === "cpd") {
        console.log("this.instructorId111111111111111");

        data = {
          logs: this.timelogForm.value.logsArray,
          periodStart: this.datesOfWeek[0].from,
          periodEnd: this.datesOfWeek[this.datesOfWeek.length - 1].to,
          totalWeekHours: this.totalWeekHour(),
          totalHoursWorked: this.totalHoursWorked,
          // jobId: this.selectedJob,
          learner: this.instructorDetails,
          type: this.apiType
        }
      } else {
        console.log("this.instructorId22222222222222", this.selectedJob, this.jobId);

        data = {

          logs: this.timelogForm.value.logsArray,
          periodStart: this.datesOfWeek[0].from,
          periodEnd: this.datesOfWeek[this.datesOfWeek.length - 1].to,
          totalWeekHours: this.totalWeekHour(),
          totalHoursWorked: this.totalHoursWorked,
          jobId: this.jobId,
          learner: this.learnerData.name,
          type: this.apiType
        }
      }
    }
    console.log('Print Single Week Report ======>', data);
    this._userTimeSheetServices.generateWeekReport(data).subscribe(res => {
      console.log('Success Response', res);
      this.loading2 = false;
      if (res && res.data) this.saveToFileSystem(res.data, format)
      else this.saveToFileSystem(res.bufferData.data, format)
    }, err => {
      console.log('Error while pdf', err);
      this.loading2 = false;
    })
  }




  printCPDReport() {
    let data = {
      logs: this.timelogForm.value.logsArray,
      periodStart: this.datesOfWeek[0].from,
      periodEnd: this.datesOfWeek[this.datesOfWeek.length - 1].to,
      totalWeekHours: this.totalWeekHour(),
      totalHoursWorked: this.totalHoursWorked,
      // jobId: this.selectedJob,
      learner: this.instructorDetails,
      type: this.apiType
    }
    console.log("CALL THIS FUNCTION", data)
    this._userTimeSheetServices.generateWeekReport(data).subscribe(res => {
      console.log('Success Response', res);
      this.loading2 = false;
      if (res && res.data) this.saveToFileSystem(res.data)
      else this.saveToFileSystem(res.bufferData.data)
    }, err => {
      console.log('Error while pdf', err);
      this.loading2 = false;
    })
  }

  totalWeekHour() {
    var totalH = 0;
    var totalM = 0;
    _.forEach(this.timelogForm.value.logsArray.value, (day) => {
      console.log("single day value", day);
      let totalTime = day.workingHours.split(':')

      totalH = totalH + Number(totalTime[0])
      totalM = totalM + Number(totalTime[1])
    })
    if (totalM > 60) {
      totalH = totalH + Math.floor(totalM / 60)
      totalM = totalM % 60
      // return totalM;
    } else if (totalM == 60) {
      this.overH = this.overH + 1
      totalM = totalM - 60
      this.overM = totalM;
      // return this.overM;
    }
    else {
      this.overM = totalM;
      // return this.overM;
    }
    totalH = this.pad(totalH)
    totalM = this.pad(totalM)
    return totalH.toString() + ':' + totalM.toString()
  }

  private saveToFileSystem(response, format?) {

    let pdfName
    if (this.apiType === "adminSheet")
      pdfName = this.instructorDetails.name
    else if (this.apiType === "cpd")
      pdfName = this.instructorDetails.name + '_cpdCalendar'
    else if (this.apiType === "dailySheet")
      pdfName = "dailySheet"
    else
      pdfName = this.learnerData.name + '_offJobHours'
    if (format === 'pdf') {

      const byteArray = new Uint8Array(response);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      saveAs(blob, pdfName);
    } else {
      const downloadLink = document.createElement("a");
      // const fileName = title + ".zip";
      downloadLink.href = response;
      downloadLink.download = pdfName + '-timesheet'
      downloadLink.click();
    }
    this.loading2 = false;
  }

  pad(value) {
    if (value < 10) {
      return '0' + value;
    } else {
      return value;
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }

  getPreviousDayLog(currentDay, currentLogIndex) {
    console.log("WHAT IS IN THE CURRENT DAY AND INDEX", currentDay, currentLogIndex)
    const control = <FormArray>this.timelogForm.controls.logsArray

    const sameDayLogs = control.value.filter((x, index) => x.date === currentDay.date && index !== currentLogIndex)
    console.log("WHAT IS IN THE SAME DAY LOGS", sameDayLogs)
    return sameDayLogs || []

    // if (index != 0) {
    //   const previousDate = moment(new Date(new Date(currentDay.date).getTime() - 24 * 60 * 60 * 1000)).format("MM/DD/YYYY")
    //   const previousDateLog = this.arrayFromDb.find((x) => x.date === previousDate)
    //   if (previousDateLog != undefined && previousDateLog._id !== 'new') return [previousDateLog]
    //   else if (previousDateLog != undefined && previousDateLog._id === 'new') return []
    //   else return []
    // } else {
    //   if (this.previousDayTimeLog._id !== 'new') return [this.previousDayTimeLog]
    //   else return []
    // }
  }


  openModel(val, i) {
    console.log("i===========>", i);
    console.log("val===========>", val);
    this.notFileShow = true
    // console.log(" this.arrayFromDb[i].details.file===========>", this.arrayFromDb[i].details.file);
    val['weekNo'] = i + 1
    let data
    if (this.apiRef == 'OTJH') {
      data = {
        data: val,
        deletedLog: this.deletedLog,
        jobId: this.jobId,
        learner: this.learnerData.userId,
        type: this.apiRef
      }
    } else if (this.apiRef == 'adminSheet') {
      data = {
        data: val,
        deletedLog: this.deletedLog,
        learner: this.userId && this.userId != undefined ? this.userId : this.instructorDetails.userId._id,
        previousDayLog: this.getPreviousDayLog(val.value, i),
        jobArray: this.jobArray,
        // projectCodeList: this.projectCodeList,
        clientList: this.clientList,
        isInstructor: true,
        type: this.apiRef,
        staffData: this.instructorDetails,
        isFatigueLogs: true
      }
    } else if (this.apiRef == 'userSheet') {
      console.log("THIS IS FOR OPERATIVE USER LOG IN")
      data = {
        data: val,
        deletedLog: this.deletedLog,
        learner: this.userId && this.userId != undefined ? this.userId : this.instructorDetails.userId._id,
        jobArray: this.jobArray,
        // projectCodeList: this.projectCodeList,
        clientList: this.clientList,
        isInstructor: true,
        type: this.apiRef
      }
    }
    else {
      data = {
        data: val,
        deletedLog: this.deletedLog,
        // jobId: this.jobId,
        // isInstructor: true,
        learner: this.userId ? this.userId : this.instructorDetails.userId._id,
        isStaff: true,
        files: this.arrayFromDb[i].files,
        type: this.apiRef
      }
    }
    console.log("data pass in model", data);
    this.openDialog(JobHoursModelComponent, data).subscribe(res => {
      console.log("updated data get", res);
      if (res == undefined) {
        this.notFileShow = false
        this.isDisplay = true
        return
      } else this.getTimeLogs('test7')
    })
  }

  /***
  * ************************************************
  * check total working **********************************
  */
  checkTotalWorkingHours(hours) {
    if (this.showTotalHoursColor == true) {
      if (hours >= 72) {
        return 'break';
      } else {
        return 'ok';
      }
    }
    else return 'ok';
    // console.log('Check Total Working Hours===>>>', hours);

  }

  fatigueIndexCalculation() {
    this.fatigueCalculation.emit({ isCal: true })
  }



  getUniquedate(logs) {
    console.log("LOGS DATA TO BE CONSIDER", logs)
    let datesArray = []
    const logsLength = logs.length
    for (let index = 0; index < logsLength; index++) {
      const element = datesArray.find((x) => x === logs[index].date)
      // console.log("ELEMENT DATA", element, moment(logs[index].date))
      if (element == undefined) datesArray.push(logs[index].date)
    }
    console.log("THIS IS THE DATE ARRAY TO BE PUSHED", datesArray)
    return datesArray
  }


  filterTimelogStatus(status) {
    console.log("STATUS OF FILTER", status)
    console.log("USER LOGS", this.days)
    console.log("CURRENT TIME LOG DATA", this.timelogForm.value.logsArray)
    let filterdLogs = []
    if (status === 'all') filterdLogs = this.days
    else {
      filterdLogs = this.days.filter((x) => {
        if (status === 'draft') {
          if (x.status === 'draft') return x
          if (x && !x.status) return x
        } else if (status === 'submitted' || status === 'pending') {
          if (x.status === 'submitted') return x
        } else if (status === 'approved') {
          if (x.status === 'approved') return x
        }
      })
    }
    if (filterdLogs && !filterdLogs.length) {
      console.log("HERE THE FILTERD LOGS", filterdLogs)
      this.filterActive = true
      this.afterFilter = {
        title: "No Logs found!",
        data: "Can not find any logs."
      }
    } else {
      this.filterActive = false
    }
    this.createForm(filterdLogs)
  }


  // API CALL
  getInstructor(instructorId) {
    console.log('check the instructor id here~~~~~', instructorId)
    this._staffService.getInstructorById(instructorId).subscribe((res => {
      console.log('Get Instructor Detail', res[0]);
      this.learnerData = res[0];
      if (this.apiType === 'adminSheet') this.instructorDetails = res[0]
    }))
  }

  getJobUsingInstructorId(instructorId) {
    console.log("InstructorId", instructorId);
    this._labourJobService.getJobByStaffId(instructorId).subscribe((response) => {
      console.log("ALL JOB LIST OF SELECTED USER", response)
      this.jobArray = response
    }, error => {
      console.log("ERRROR WHILE GET JOB LIST OF STAFF USER", error)
    })
  }


  calculatePercent(worked, otjh) {
    console.log("calculatePercent of ", worked, otjh)
    var timeone = worked.hours + ":" + worked.minutes; // time elapsed
    var timetwo = otjh; // total time 
    this.percent = (100 * this.totalSeconds(timeone) / this.totalSeconds(timetwo)).toFixed(2);
    if (this.percent == 'NaN') {
      this.percent = '0'
    }
    console.log("pct", this.percent, typeof this.percent)
  }

  totalSeconds(time) {
    console.log("time in totalSeconds", time)
    var parts = time.split(':');
    return parts[0] * 3600 + parts[1] * 60;
  }

  addOTJHTimeLogs(event) {
    console.log("event when enter something", event.target.value);
    let regex = new RegExp(/^([0-9]{1,3}):[0-5][0-9]$/g)
    this.totalHoursValid = regex.test(event.target.value);
    if (this.totalHoursValid) {
      this.isOtjhDisplay = true
      console.log("this.houursValid", this.totalHoursValid)
      // this.totalWorkingHours()
    } else {
      console.log("this is not valid");
      this.isOtjhDisplay = false
    }

  }

  updateTotalOTJH() {
    this.isOtjhDisplay = false;
    console.log("here is the total hours to changed", this.totalOTJH, this.learner, this.jobId);
    let obj = {
      totalOTJH: this.totalOTJH,
      learnerId: this.learnerData._id,
      jobId: this.jobId
    }
    this._learnerService.updateTotalOTJH(obj).subscribe((updated) => {
      console.log("total OTJH updated", updated);
      this.openSnackBar("Total required hours update successfully!", "OK")
      this.calculatePercent(this.totalHoursWorked, this.totalOTJH)
    }, err => {
      console.log("error while update logs", err);

    })
  }


  getTimeLogs(test?) {
    // this.loading = true
    this.loading2 = true
    // this.notFileShow = false
    console.log("getTimeLogs function call from here!!!", test);

    console.log("get time log function call ***********************", this.apiRef)
    let data = this.getData()
    console.log("data to be send to server: ", data, this.arrayFromDb);

    this._userTimeSheetServices.getTimelog(JSON.stringify(data))
      .subscribe((res) => {
        let data = res.result
        console.log("this is the response of time log data", res);
        this.previousDayTimeLog = res && res.previousDayLog ? res.previousDayLog.timeLogs[0] : {}
        this.arrayFromDb = data.timeLogs;
        this.timeCalculated = data.timeCalculated
        this.fatigueIndex = data.fatigueIndex
        if (this.instructorId) this.plannedHours = res.jobHours.plannedhours
        if (this.instructorId) this.actualHours = res.jobHours.actualHours
        // this.riskIndex = data.riskIndex
        this.weekno = this.arrayFromDb.length
        this.editing = false
        this.index = null
        // this.loading = false
        this.loading2 = false
        console.log('Arrayform db', this.fatigueIndex, this.riskIndex);
        this.days = this.arrayFromDb
        this.notFileShow = true
        this.createForm(this.days)

        this.totalWorkingHours();
        if (this.apiRef === 'OTJH') this.calculatePercent(this.totalHoursWorked, this.totalOTJH)
        // this.cd.detectChanges()
        // this.updateData(this.days);
        console.log("here is time log get response", res)
      }, (error) => {
        this.loading = false
        console.log("failed time log response gett", error);

      })
  }


  getData() {
    let obj
    console.log("what is the userId", this.userId, this.labourJobId);

    if (this.apiRef == 'cpd') obj = { userId: this.instructorDetails.userId._id, date: this.getWeekDates() }

    else if (this.apiRef == 'OTJH') obj = { userId: this.learnerData.userId, jobId: this.jobId, date: this.getWeekDates() }

    else if (this.apiRef == 'dailySheet') {
      let date = this.today
      let newDate
      newDate = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()
      obj = {
        date: [newDate],
        isDailyTimeLog: true
      }
    }
    else if (this.apiRef == 'adminSheet') obj = { userId: this.userId ? this.userId : this.instructorDetails.userId._id, date: this.datesOfWeek, isInstructor: true, labourJobId: this.labourJobId }

    else if (this.apiRef == 'userSheet') obj = { userId: this.userId, date: this.datesOfWeek, isInstructor: true }

    return obj
  }

  getWeekDates() {
    console.log("Total dates of week", this.datesOfWeek);

    const weekNumberArray = this.datesOfWeek.map(function (value) {
      let date = new Date(value.weekStartDate)
      let newDate = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()
      let objData = {
        date: newDate,
        weekNumber: value.weekNumber
      }
      return objData
    })
    return weekNumberArray
  }


  submitDetail() {
    // this.loading = true
    this.notFileShow = false
    this.finalArray = []
    console.log("this.days~~~~~~>", this.timelogForm.value.logsArray);
    if (this.instructorId) {
      _.forEach((this.timelogForm.value.logsArray), (singleDate, index) => {
        console.log("SINGLE DATE VALUE", singleDate)
        if (!singleDate.isJob && (singleDate.start != '00:00' || singleDate.end != '00:00' || singleDate._id != 'new') || (singleDate.workingHours == '00:00' && (singleDate.other != '' || singleDate.extraDetails != ''))) {
          let temp = {
            _id: singleDate._id,
            details: {},
            date: this._userTimeSheetServices.covertDateFormate(singleDate.date, 'MM/DD/YYYY'),
            hours: singleDate.hours,
            minutes: singleDate.minutes,
            workingHours: singleDate.workingHours,
            start: singleDate.start,
            end: singleDate.end,
            status: singleDate.status,
            // job: singleDate.job,
            travel: singleDate.travel,
            totalHours: singleDate.totalHours,
            multipleLogs: singleDate.multipleLogs,
            multipleExpense: singleDate.multipleExpense,
            multipleDeduction: singleDate.multipleDeduction,
          }
          // if (singleDate && singleDate.job && singleDate.job !== null) temp['job'] = singleDate.job
          temp.details = {
            extraDetails: singleDate.extraDetails,
            other: singleDate.other,
            shiftInfo: singleDate.shiftInfo,
            nightAway: singleDate.nightAway,
            livingAllowance: singleDate.livingAllowance,
            projectCode: singleDate.projectCode,
            payRate: singleDate.payRate,
            paidHours: singleDate.paidHours,
            expense: singleDate.expense,
            deduction: singleDate.deduction,
          }
          this.finalArray.push(temp);
        }
      })
    } else {
      _.forEach((this.timelogForm.value.logsArray), (singleDate, index) => {
        console.log('this.Days===========>>>>>>', this.timelogForm.value.logsArray);
        console.log('singleDate===========>>>>>>, index', singleDate, index);
        if ((singleDate.workingHours != '00:00' || singleDate._id != 'new') || (singleDate.workingHours == '00:00' && (singleDate.other != '' || singleDate.extraDetails != ''))) {
          // let files = []
          // files.push(singleDate.file)
          let temp = {
            _id: singleDate._id,
            details: {},
            files: singleDate.file,
            date: singleDate.weekStartDate,
            weekStartDate: singleDate.weekStartDate,
            weekEndDate: singleDate.weekEndDate,
            weekNumber: singleDate.weekNumber,
            hours: singleDate.hours,
            minutes: singleDate.minutes,
            workingHours: singleDate.workingHours,
            deletedFiles: this.deletedFiles,
          }
          temp.details = {
            other: singleDate.other,
            extraDetails: singleDate.extraDetails,
          }
          this.finalArray.push(temp);
        }
      })
    }



    console.log("this.finalArray----->", this.finalArray);
    let data
    if (this.instructorId) {
      console.log("this is first one");

      data = {
        date: this.finalArray,
        deletedLog: this.deletedLog,
        learner: this.userId ? this.userId : this.instructorDetails.userId._id,
        type: this.apiRef
      }
    } else if (this.jobId) {
      console.log("this is second one");
      data = {
        date: this.finalArray,
        deletedLog: this.deletedLog,
        jobId: this.jobId,
        learner: this.learnerData.userId,
        type: this.apiRef
        // details: this.learnerSelectType
        // instructorId: this.instructorId
      }
    } else {
      console.log("this is last one");
      data = {
        date: this.finalArray,
        deletedLog: this.deletedLog,
        learner: this.learnerData.userId._id,
        type: this.apiRef
      }
    }
    console.log('finalArray===========>>>>>>', data);
    this._userTimeSheetServices.addTimelog(data).subscribe((res) => {
      //   this.finalArray = [];
      //   this.getValuesUsingDates()
      // this.editing = false;
      this.index = -1;
      console.log("timelog data added successfully!!!", res)
      this.getTimeLogs('test10')
      this.openSnackBar("Logs added successfully!", "OK")
      this.loading = false
    }, err => {
      console.log("here is some error occure!!!", err)
      this.loading = false
    })
  }

  getAllYearWeeks() {
    return new Promise((resolve, reject) => {
      this._timeSheetSetvice.getRailWeekDates({}).subscribe((weekList) => {
        // this.allWeeks = weekList
        this.allYearweekList = weekList
        console.log("ALL WEEK LIST OF SELECTED YEAR", weekList)
        resolve(weekList)
      }, error => {
        console.log("error while get week list", error);
      })
    })
  }

  getClientList() {
    this._clientService.getClients().subscribe((res) => {
      console.log("THIS IS THE CLIENT LIST TO BE DISPLAY", res)
      this.clientList = res.map((x) => {
        let obj = {
          name: x.name,
          _id: x._id,
          // projectCodes: x.projectCodes
        }
        return obj
      })
      console.log("THIS IS THE FINAL CLIENT LIST", this.clientList)
    }, error => {
      console.log("ERROR WHILE GET CLIENTS", error)
    })
  }

  // Get Project code list of all clients
  getProjectCodeList() {
    this._clientService.getProjectCodeList().subscribe((res) => {
      console.log("RESPONSE OF PROJECT CODE", res)
      this.projectCodeList = res
    }, error => {
      console.log("ERROR WHILE GET PROJECT CODE LIST", error)
    })
  }



  submitTimelogForApproval() {
    let modalContent;
    let next_action;
    console.log("SUBMITTED LOGS", this.selectedTimelog)
    if (this.userRole.isOperative) {
      modalContent = _operativeTimesheetModalData;
      next_action = "submitted";
    } else {
      modalContent = _adminTimesheetApprovalModalData;
      next_action = "approved";
    }
    let data = {
      modalContent: modalContent,
      timeLogs: this.selectedTimelog,
      displayDates: this.getUniquedate(this.selectedTimelog),
      isApproval: true,
    };
    this._utilityService
      .commonDialogBoxOpen(CommentsComponent, data)
      .afterClosed()
      .subscribe((res) => {
        console.log("THIS IS THE RESPONSE", res)
        if (res) {
          const payload = {
            logs: this.selectedTimelog,
            next_action: next_action
          };
          console.log("checking payload :: ", payload);
          this._labourJobService.submitTimelogForApproval(payload, false).subscribe((data) => {
            console.log("DATA AFTER UPDATED", data)
            // let jobData = data.displayJobs[0];
            // this.operativeTimelogs = jobData.operativeLogs;
            // this.filterTimeloList();
            this.selectedTimelog = [];
            if (this.isApproved) {
              this.isApproved = false
            }
            this.getTimeLogs()
            this._utilityService.openSnackBar("Logs have been submitted for approval.", "OK")
          },
            (error) => {
              console.log("Error from updating timelogs : ", error);
              this._utilityService.handleSnackBar({ msg: "Something went wrong", button: "Ok" })
            });
        } else {
          this.selectedTimelog = [];
          this.isApproved = false
          const logs = this.multipleVisitorsGroup.controls;
          for (let i = 0; i < logs.length; i++) {
            logs[i].patchValue({ checked: false })
          }
        }
      });
  }



  /**
 * This function will reject Timelog.
 * Only Client and Admin can reject the Timelog.
 */
  submitTimelogForRejection() {
    let modalContent;
    modalContent = _adminTimesheetRejectionModalData;
    let data = {
      modalContent: modalContent,
      timeLogs: this.selectedTimelog,
      isApproval: true,
    };
    const dialogRef = this._utilityService
      .commonDialogBoxOpen(CommentsComponent, data)
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          const newList = this.selectedTimelog.map(({ date, ...rest }) => {
            return rest;
          });
          const payload = {
            logs: this.selectedTimelog,
            jobId: this.currentJob,
            next_action: "reject",
          };
          console.log("checking payload for rejection :: ", payload);
          this._labourJobService.submitTimelogForApproval(payload, false).subscribe(
            (data) => {
              // let jobData = data.displayJobs[0];
              // this.operativeTimelogs = jobData.operativeLogs;
              // this.filterTimeloList();
              this.getTimeLogs()
              this.selectedTimelog = [];
              this._utilityService.openSnackBar("Logs are successfully rejected and moved for operative resubmission.", "OK");
            },
            (error) => {
              console.log("Error from updating timelogs : ", error);
              this._utilityService.handleSnackBar({ msg: "Something went wrong", button: "Ok" });
            }
          );
        }
      });
  }



  /**
    * This function will submit all the appropriate timelogs for Approval(Operatives users only).
    */
  submitAllTimelogForApproval() {
    /** @note if selectedTimelog has already timelogs then remove first and add new timelogs. */
    let logs = this.timelogForm.value.logsArray;
    this.selectedTimelog = [];
    for (let i = 0; i < logs.length; i++) {
      let timelogs = logs[i];
      console.log('timelogs :: ', timelogs);
      // for (let j = 0; j < timelogs.logs.length; j++) {
      if (timelogs.status === 'draft' && timelogs._id !== 'new' && !timelogs.job) {
        const obj = {
          logId: timelogs._id,
          userId: this.userId && this.userId != undefined ? this.userId : this.instructorDetails.userId._id,
          status: timelogs.status,
          date: timelogs.date,
          // job: timelogs.job, /** @notes adding jobs in individual timelogs for approval. */
        };
        this.selectedTimelog.push(obj);
      }
      // }
    }
    if (this.selectedTimelog.length) {
      console.log("this.selectedTimelog :: ", this.selectedTimelog);
      this.submitTimelogForApproval();
    } else {
      this._utilityService.openSnackBar(
        "No logs are eligible for Approval.",
        "OK"
      );
    }
  }

}